import { ScrollArea } from '@mantine/core';
import { GlobalMenuRenderer } from '../../layouts/menu/core/GlobalMenuRenderer';
import classes from './DomainSidebar.module.css';

/**
 * GlobalSidebar Component
 * Displays global navigation menu sections (App, User, Admin)
 * Independent of specific domain context
 *
 * Uses the new Menu Domain Contract architecture:
 * - GlobalMenuRenderer queries the global menu provider
 * - Menu structure is defined in domain/providers/globalMenu.tsx
 * - Supports role/permission-based visibility
 * - Respects menu UI preferences (iconOnly, density, etc.)
 */
export default function GlobalSidebar() {
  return (
    <ScrollArea
      h="100%"
      type="scroll"
      scrollbarSize={6}
      scrollHideDelay={300}
      classNames={{
        viewport: classes.viewport,
        scrollbar: classes.scrollbar,
        thumb: classes.thumb,
      }}
      styles={{
        root: {
          height: '100%',
        },
      }}
    >
      <GlobalMenuRenderer />
    </ScrollArea>
  );
}
